import { fetcher } from '@commenda/utils';
import { API_BASE_PATH } from './constants';

export interface TUnassignBusinessEntitiesFromServiceRequestParams {
  serviceRequestId: string;
  corporationIds: number[];
}

export const unassignBusinessEntitiesFromServiceRequest = async (
  params: TUnassignBusinessEntitiesFromServiceRequestParams
): Promise<Response> => {
  const { serviceRequestId, corporationIds } = params;

  return fetcher(
    `${API_BASE_PATH}/${serviceRequestId}/business-entities/unassign`,
    {
      method: 'DELETE',
      body: { corporationIds },
    },
    undefined
  );
};
